'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgContainer = require('./SvgContainer');

var _SvgContainer2 = _interopRequireDefault(_SvgContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BagCheckSharp = function BagCheckSharp(props) {
  return _react2.default.createElement(_SvgContainer2.default, {
    height: props.height,
    width: props.width,
    color: props.color,
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0,
    className: props.className
  }, _react2.default.createElement('svg', {
    style: props.style,
    className: props.cssClasses,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 512 512'
  }, props.title ? _react2.default.createElement('title', null, props.title) : '', _react2.default.createElement('path', {
    d: 'M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm50.81 252.12l-61.37-71.72 24.31-20.81L230 350.91l87.51-109.4 25 20z'
  })));
};

BagCheckSharp.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
BagCheckSharp.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,
  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,
  // functions
  onClick: _propTypes2.default.func
};
exports.default = BagCheckSharp;
module.exports = exports['default'];